import { URL_IMG } from '@/constants/ui'
import { colorsPalette } from './theme-config'

const appConfig = {
  theme: {
    colors: colorsPalette,
  },
  fontSize: '16px',
  mode: 'light',
  version: '1.0.0',
  name: 'Heil Hydra Shop',
  locales: ['vi'],
  defaultLocale: 'vi',
}
const INTERNAL_DATA = {
  hotline: '1900 636 648',
  address: '1073/23 Cách Mạng Tháng Tám, P. Tân Sơn Nhất, TP. Hồ Chí Minh',
  address_link: 'https://maps.app.goo.gl/9b2CvhNroXQEkjn78', // Google Maps link
  email: 'support@hydrashop.vn',
  caption: 'Website E-commerce by Retail team',
  logo: '/assets/images/logo.png',
  shortLogo: '/assets/images/short-logo.png',
  shortLogoDark: '/assets/images/short-logo-dark.png',
  avatar_default: '/assets/images/ava-default.png',
  taxID: '0319279370',
  legalName: 'Heil Hydra',
  priceRange: '100.000đ - 1.000.000đ',
  geo: { latitude: 10.790966, longitude: 106.656125 },
  openingHours: { opens: '09:00', closes: '22:00' },
  streetAddress: '1073/23 Cách Mạng Tháng Tám',
  addressLocality: 'Phường Tân Sơn Nhất',
  addressRegion: 'TP. Hồ Chí Minh',
  postalCode: '700000',
  addressCountry: 'VN',
}
const REF_COOKIE_NAME = 'user_ref'
const AFFILIATE_CLICKED_REFS_KEY = 'affiliate_clicked_refs'
// key tương ứng key trong file dịch (Breadcrumb >>)
const HEADER_MENU = [
  {
    name: 'Hoạt động của Hydra',
    key: 'hydra-activities',
    link: '/blog',
  },
  {
    name: 'Bộ sưu tập mới',
    key: 'new-collection',
    link: '/collections',
  },
  {
    name: 'Trung tâm hỗ trợ',
    key: 'support-center',
    link: '/help/quy-che-va-chinh-sach',
  },
]

const MENU_MOBILE = (t: any) => [
  // {
  //   key: t('Về MONA', { name: 'Hydra' }),
  //   link: '/about',
  // },
  // {
  //   key: t('Blog'),
  //   link: '/blog',
  // },
  // {
  //   key: t('Liên hệ'),
  //   link: '/contact',
  // },
  // {
  //   key: t('Thành viên'),
  //   link: '/membership',
  // },
  // {
  //   key: t('UserProfile.signin'),
  //   link: '/login',
  //   condition: (isAuthenticated: boolean) => !isAuthenticated,
  // },
  // {
  //   key: t('UserProfile.signup'),
  //   link: '/register',
  //   condition: (isAuthenticated: boolean) => !isAuthenticated,
  // },
]

const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/heil.hydra.official',
  youtube: 'https://www.youtube.com/@heil.hydra.official',
  instagram: 'https://instagram.com/heil.hydra.official',
  messenger: 'https://m.me/824953010706483',
  zalo: 'https://zalo.me/2365065712824147986',
  shoppe: '#',
  lazada: '#',
  tiktok: 'https://tiktok.com/@heil.hydra.official',
}
export const BO_CONG_THUONG = {
  image: '/assets/images/bct.png',
  link: 'http://online.gov.vn/Home/WebDetails/139681',
}
const VIDEO_BANNER = 'https://api.hydrashop.vn/pub/media/video/video-banner-home.mp4'
const VIDEO_BANNER_MOBILE = 'https://api.hydrashop.vn/pub/media/video/video-banner-home-mobile.mp4'
export type SettingsType = typeof appConfig
export {
  AFFILIATE_CLICKED_REFS_KEY,
  HEADER_MENU,
  INTERNAL_DATA,
  MENU_MOBILE,
  REF_COOKIE_NAME,
  SOCIAL_LINKS,
  VIDEO_BANNER,
  VIDEO_BANNER_MOBILE,
}
export default appConfig
